import {Form, InputNumber, Modal,  App,  Row, Col,  Space, Input } from 'antd'
import { ASSETS_APPLICATION_BASE } from '../../config/api'
import React, { useEffect,useState } from 'react'
import classes from './invoice.module.css'
import { useKaipiaodanUpdateSaveMutation, useKaipiaodanUpdateQuery } from '../../store/DianShangYeWuApi';
import Icon from '../../cpn/Icon';
import OCRTextArea from '../../cpn/OCRTextArea';
import ClientSelect from '../../system/client/ClientSelect';
import UploadPic from '../../cpn/UploadPic';
import DocumentRule from '../../cpn/DocumentRule';
import Asterisk from '../../cpn/Asterisk';
// import InvoiceWithdraw from './InvoiceWithdraw';
import InvoiceDel from './InvoiceDel';
import ReportStateTag from '../../cpn/StateTag';
import InvoiceTypeSelect from '../../system/invoice/invoiceType/InvoiceTypeSelect';
import ClientInvoiceSelect from '../../system/client/ClientInvoiceSelect';
import InvoiceNodeEdit from './InvoiceNodeEdit';
import { useKPSQtijiaoMutation } from '../../store/DianShangYeWuApi';
function InvoiceEditReportEdit(props) {
    const { message } = App.useApp();
    const [open,setOpen] = React.useState(false);
    const [info,setInfo] = React.useState({
        'kpsq_price':'',   
        'kpsq_uid':'',
        'kpsq_uname':'',
        'kpsq_content':'',
        'kpsq_bzd_id':'',
        'kpsq_qy_id':'',
        'kpsq_qy_name':'',
        'kpsq_kh_id':'',
        'kpsq_kh_name':'',
        'kpsq_type_id':'',
        'kpsq_type_name':'',
        'kpsq_amount':'',
        'kpsq_bzd_xuhao':'',
        'kpsq_bzd_name':'',
        'kpsq_date':'',
        'kpsq_bzd_date_end':'',
        'kpsq_num':'',
        'kpsq_name':'',
        'kpsq_bzd_date':'',
        'kpsq_khyhzh_id':'',
        'kpsq_khyhzh_name':'',
        'kpsq_image_name':'',
        'kpsq_image_file':'',
        'kpsq_bm_id':'',
        'kpsq_bm_name':'',
        'kpsq_state':'',
        'kpsq_ctime':'',
        'kpsq_state_time':'',
    })
    const {data, isSuccess} = useKaipiaodanUpdateQuery({kpsq_id:props.kpsq_id},{skip:!open});
    const [form] = Form.useForm();
    const [updateSave] = useKaipiaodanUpdateSaveMutation();  
    const [defaultFileList, setDefaultFileList] = useState([]);
    
    useEffect(() => {
        if(isSuccess && data.Status === 'success'){
            setInfo({
                'kpsq_price': data.Result.kpsq_price,   
                'kpsq_uid': data.Result.kpsq_uid,
                'kpsq_uname': data.Result.kpsq_uname,
                'kpsq_content': data.Result.kpsq_content,
                'kpsq_bzd_id': data.Result.kpsq_bzd_id,
                'kpsq_qy_id': data.Result.kpsq_qy_id,
                'kpsq_qy_name': data.Result.kpsq_qy_name,
                'kpsq_kh_id': data.Result.kpsq_kh_id,
                'kpsq_kh_name': data.Result.kpsq_kh_name,
                'kpsq_type_id': data.Result.kpsq_type_id,
                'kpsq_type_name': data.Result.kpsq_type_name,
                'kpsq_amount': data.Result.kpsq_amount,
                'kpsq_bzd_xuhao': data.Result.kpsq_bzd_xuhao,
                'kpsq_bzd_name': data.Result.kpsq_bzd_name,
                'kpsq_date': data.Result.kpsq_date,
                'kpsq_bzd_date_end': data.Result.kpsq_bzd_date_end,
                'kpsq_num': data.Result.kpsq_num,
                'kpsq_name': data.Result.kpsq_name,
                'kpsq_bzd_date': data.Result.kpsq_bzd_date,
                'kpsq_khfpxx_id': data.Result.kpsq_khfpxx_id,
                'kpsq_khfpxx_name': data.Result.kpsq_khfpxx_name,
                'kpsq_image_name': data.Result.kpsq_image_name,
                'kpsq_image_file': data.Result.kpsq_image_file,
                'kpsq_bm_id': data.Result.kpsq_bm_id,
                'kpsq_bm_name': data.Result.kpsq_bm_name,
                'kpsq_state': data.Result.kpsq_state,
                'kpsq_ctime': data.Result.kpsq_ctime,
                'kpsq_state_time': data.Result.kpsq_state_time,
                'kpsq_ddsr_id': data.Result.kpsq_ddsr_id,
            });
            setDefaultFileList(Array.isArray(data.Result.kpsq_image_name) ? data.Result.kpsq_image_name.filter(Boolean) : []);
            const imageNameArray = Array.isArray(data.Result.kpsq_image_name) 
            ? data.Result.kpsq_image_name.filter(Boolean)
            : (data.Result.kpsq_image_name ? [data.Result.kpsq_image_name] : []);
            const imageFileArray = Array.isArray(data.Result.kpsq_image_file)
                ? data.Result.kpsq_image_file.filter(Boolean)
                : (data.Result.kpsq_image_file ? [data.Result.kpsq_image_file] : []);

            const fileListForForm = imageNameArray.map((serverFileName, i) => {
                // 确保 URL 是完整路径
                // 根据 setupProxy.js，/api 代理到 fxapi.zzddww.com，用于访问图片
                let fullUrl = serverFileName;
                if (serverFileName.startsWith('http://')) {
                    // 完整 URL，直接使用
                    fullUrl = serverFileName;
                } else if (serverFileName.startsWith('/')) {
                    // 已经是相对路径，检查是否需要添加 /api 前缀
                    if (!serverFileName.startsWith('/api/') && !serverFileName.startsWith('/NeiZhangApi/')) {
                        fullUrl = `/api${serverFileName}`;
                    } else {
                        fullUrl = serverFileName;
                    }
                } else {
                    // 只是文件名，使用 /api/assets/images/application/ 路径
                    fullUrl = `${ASSETS_APPLICATION_BASE}/${serverFileName}`;
                }
                
                // 获取显示名称
                const displayName = imageFileArray[i] || undefined;
                
                return {
                    uid: `file-${i}-${serverFileName}`,
                    name: displayName || serverFileName || `文件${i + 1}`,
                    status: 'done',
                    url: fullUrl,
                    response: {
                        Result: serverFileName // 保存服务器文件名用于提交
                    }
                };
            });       
            form.setFieldsValue({
                    'kpsq_price': data.Result.kpsq_price,  
                    'kpsq_uid': data.Result.kpsq_uid,
                    'kpsq_uname': data.Result.kpsq_uname,
                    'kpsq_content': data.Result.kpsq_content,
                    'kpsq_bzd_id': data.Result.kpsq_bzd_id,
                    'kpsq_bzd_name': data.Result.kpsq_bzd_name,
                    'kpsq_kh_id': data.Result.kpsq_kh_id,
                    'kpsq_kh_name': data.Result.kpsq_kh_name,
                    'kpsq_name': data.Result.kpsq_name,
                    'kpsq_type_name': data.Result.kpsq_type_name,
                    'kpsq_num': data.Result.kpsq_num,
                    'kpsq_bm_name': data.Result.kpsq_bm_name,
                    'kpsq_date': '',
                    'kpsq_khfpxx_name': data.Result.kpsq_khfpxx_name,
                    'kpsq_amount': data.Result.kpsq_amount,
                    'kpsq_image_name': imageNameArray,
                    'kpsq_image_file': fileListForForm,
            })

        }
        
        
        
        
    }, [data, isSuccess,form])    

   
    //提交借款单
    const [tijiao] = useKPSQtijiaoMutation()
    const [isSubmitting, setIsSubmitting] = useState(false)
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.kpsq_kh_name}</a>
            <Modal
                open={open} 
                onCancel={() => {setOpen(false)}}
                width={1330}
                form={form}
                footer={null}
            >
                <Form
                    form={form}
                    className={classes.form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                >
                    <Row style={{width:"1280px"}}>
                        <Col span={4} className={classes.row_top_left} style={{borderTop:'3px solid #FF6600',borderLeft:'3px solid #FF6600'}}></Col>
                        <Col span={16} className={classes.row_top_middle} style={{color:'#FF6600',borderTop:'3px solid #FF6600'}}>开票申请</Col>
                        <Col span={4} className={classes.row_top_right} style={{borderTop:'3px solid #FF6600',borderRight:'3px solid #FF6600'}}></Col>
                         {/* 第一行 */}
                        <Col span={2} className={classes.col_top_label} style={{borderLeft:'3px solid #FF6600',color:'#FF6600'}}><Asterisk color='red'/> 团队名称</Col>
                        <Col span={6}  className={classes.col_top_input}>
                           {info.kpsq_bzd_name}
                        </Col>  
                        <Col span={2} className={classes.col_top_label} ><Asterisk color='red'/> 开票金额</Col>
                        <Col span={6}  className={classes.col_top_input}>
                            <Form.Item 
                                name='kpsq_amount'
                                noStyle
                            >
                                <InputNumber 
                                    placeholder='请输入金额' 
                                    onChange={(value) => {
                                        setInfo(prevState => ({ ...prevState, kpsq_amount: value }))
                                    }}
                                    style={{ width: '310px' }}
                                    min={0.01}
                                />
                            </Form.Item>
                        </Col>  
                        <Col span={2}  className={classes.col_top_label} ><Asterisk color='red'/> 部门</Col>
                        <Col span={6}  className={classes.col_right_input}  style={{borderRight:'3px solid #FF6600'}}>
                           {info.kpsq_bm_name}
                        </Col> 
                        
                        {/* 第二行 */}

                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF6600'}}><Asterisk color='red'/> 客户</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <ClientSelect
                                name='kpsq_kh_name'
                                placeholder='请选择客户'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, kpsq_kh_id: value, kpsq_kh_name: label }))
                                }}
                                style={{width: '230px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                                yh_id={props.yh_id}
                                defaultId={info.kpsq_kh_id}
                                wrapperCol={{span:24}}
                                clientAdd={true}
                            />
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 开票信息</Col>
                        <Col span={14}  className={classes.col_middle_input} style={{borderRight:'3px solid #FF6600'}}>
                           <ClientInvoiceSelect
                                name='kpsq_khfpxx_name' 
                                placeholder='请选开票信息'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, kpsq_khfpxx_id: value, kpsq_khfpxx_name: label }))
                                }}
                                style={{width: '100%'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                                yh_id={props.yh_id}
                                defaultId={info.kpsq_khfpxx_id}
                                wrapperCol={{span:24}}
                                kh_id={info.kpsq_kh_id}
                            />
                        </Col>
                        {/* 第三行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF6600'}}><Asterisk color='red'/> 开票项目</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                            <Form.Item name='kpsq_name' noStyle>
                               <Input 
                                    placeholder='请输入开票项目' 
                                    value={info.kpsq_name}
                                    style={{ width: '100%' }}
                                    onChange={(e) => {
                                         setInfo(prevState => ({ ...prevState, kpsq_name: e.target.value }))
                                    }}
                               />
                            </Form.Item>
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}><Asterisk color='red'/> 发票类型</Col>
                        <Col span={6}  className={classes.col_middle_input} style={{display:'flex',alignItems:'center',justifyContent:'left',}}>
                            <InvoiceTypeSelect
                                name='kpsq_type_name'
                                placeholder='请选择发票类型'
                                onChange={(value,label) => {
                                    setInfo(prevState => ({ ...prevState, kpsq_type_id: value, kpsq_type_name: label }))
                                }}
                                value={info.kpsq_type_name}
                                style={{width: '310px'}}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                qy_id={props.qy_id}
                            />
                        </Col> 
                        <Col span={2} className={classes.col_middle_label}>备注</Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{display:'flex',alignItems:'center',justifyContent:'left',borderRight:'3px solid #FF6600'}}>
                           <Form.Item name='kpsq_content' noStyle>
                                <OCRTextArea
                                    value={info.kpsq_content}
                                    onChange={(e) => {
                                        setInfo(prevState => ({ ...prevState, kpsq_content: e.target.value }))
                                    }}
                                    language="chi_sim"
                                />
                            </Form.Item>
                        </Col> 
                        {/* 第四行 */}
                        <Col span={2}  className={classes.col_middle_label} style={{borderLeft:'3px solid #FF6600'}}>附件</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                           <UploadPic
                                name='kpsq_image_file'
                                onChange={(e,f) => {
                                    setInfo(prevState => ({ ...prevState, kpsq_image_file: e, kpsq_image_name: f }))
                                }}
                                maxCount={5}
                                style={{ width: '100%' }}
                                formStyle={{marginBottom: 0,width: '100%'}}
                                defaultFileList={defaultFileList}
                            />
                        </Col>
                        <Col span={2}  className={classes.col_middle_label}>编号 / 状态</Col>
                        <Col span={6}  className={classes.col_middle_input}>
                              {props.kpsq_id}&emsp;<ReportStateTag state={props.kpsq_state} />
                        </Col> 
                        <Col span={2} className={classes.col_middle_label}>发票下载 </Col>
                        <Col span={6}  className={classes.col_middle_right_input} style={{borderRight:'3px solid #FF6600'}}>
                          
                        </Col> 
                        {/* 第五行 */}
                       
                        <Col span={24} className={classes.bottom_row}>
                            <InvoiceNodeEdit 
                                qy_id={props.qy_id} 
                                user_id={props.yh_id} 
                                yh_name={props.yh_name} 
                                kpsq_id={props.kpsq_id} 
                                kpsq_state={props.kpsq_state}
                                kpsq_ctime={info.kpsq_ctime}
                                kpsq_uname={info.kpsq_uname}
                                kpsq_state_time={info.kpsq_state_time}
                            />
                        </Col>                                           
                    </Row>   
                    <Row>
                        <Col span={24} style={{textAlign: 'right',paddingTop: '10px',display:'flex',justifyContent:'space-between'}}>
                            <DocumentRule/>
                            <Space size={20}>
                                <Icon 
                                    key='submit' 
                                    type='save' 
                                    onClick={() => {
                                        if(info.kpsq_name === ''){
                                            message.error('请输入开票项目');
                                            return;
                                        }
                                        if(info.kpsq_amount === ''){
                                            message.error('请输入开票金额');
                                            return;
                                        }
                                        if(info.kpsq_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.kpsq_khfpxx_id === ''){
                                            message.error('请选择开票信息');
                                            return;
                                        }  
                                        if(info.kpsq_type_id === ''){
                                            message.error('请选择发票类型');
                                            return;
                                        }          
                                        
                                        
                                        updateSave({
                                            'kpsq_id': props.kpsq_id,
                                            'kpsq_price': info.kpsq_price,
                                            'kpsq_uid': props.yh_id,
                                            'kpsq_uname': props.yh_name,
                                            'kpsq_content': info.kpsq_content,
                                            'kpsq_bzd_id': info.kpsq_bzd_id,
                                            'kpsq_qy_id': props.qy_id,
                                            'kpsq_qy_name': props.qy_name,
                                            'kpsq_kh_id': info.kpsq_kh_id,
                                            'kpsq_kh_name': info.kpsq_kh_name,
                                            'kpsq_type_id': info.kpsq_type_id,
                                            'kpsq_type_name': info.kpsq_type_name,
                                            'kpsq_amount': info.kpsq_amount,
                                            'kpsq_bzd_xuhao': '',
                                            'kpsq_bzd_name': info.kpsq_bzd_name,
                                            'kpsq_date': info.kpsq_date,
                                            'kpsq_bzd_date_end': info.kpsq_bzd_date_end?info.kpsq_bzd_date_end:'',
                                            'kpsq_num': info.kpsq_num, 
                                            'kpsq_name': info.kpsq_name,
                                            'kpsq_bzd_date': info.kpsq_bzd_date?info.kpsq_bzd_date:'',
                                            'kpsq_khfpxx_id': info.kpsq_khfpxx_id,
                                            'kpsq_khfpxx_name': info.kpsq_khfpxx_name,
                                            'kpsq_image_name': info.kpsq_image_name?info.kpsq_image_name:'',
                                            'kpsq_image_file': info.kpsq_image_file?info.kpsq_image_file:'',
                                            'kpsq_bm_id': info.kpsq_bm_id,
                                            'kpsq_bm_name': info.kpsq_bm_name,
                                            'kpsq_state': '1',
                                            'kpsq_ddsr_id': '',
                                        }).then(res => {
                                            if(res.data.Status==='success'){
                                                setOpen(false);
                                                message.success('修改成功');
                                                form.resetFields();  
                                            }else{
                                                message.error('修改失败！' + res.data.Message);
                                            }
                                        })     
                                    }}
                                />
                                {/* {props.kpsq_state === '2' && <InvoiceWithdraw kpsq_id={props.kpsq_id} />} */}
                                {(props.kpsq_state === '1' || props.kpsq_state === '4') && <InvoiceDel kpsq_id={props.kpsq_id} />}
                                <Icon 
                                    type='submit' 
                                    onClick={() => {
                                        console.log(info);
                                        // 如果正在提交中，直接返回
                                        if (isSubmitting) {
                                            return;
                                        }
                                        
                                        // 先进行验证
                                    
                                        if(info.kpsq_name === ''){
                                            message.error('请输入开票项目');
                                            return;
                                        }
                                        if(info.kpsq_amount === ''){
                                            message.error('请输入开票金额');
                                            return;
                                        }
                                        if(info.kpsq_kh_id === ''){
                                            message.error('请选择客户');
                                            return;
                                        } 
                                        if(info.kpsq_khfpxx_id === ''){
                                            message.error('请选择开票信息');
                                            return;
                                        }  
                                        if(info.kpsq_type_id === ''){
                                            message.error('请选择发票类型');
                                            return;
                                        }     
                                        
                                        // 验证通过后，设置提交状态
                                        setIsSubmitting(true);
                                        tijiao({
                                            'kpsq_id': props.kpsq_id,
                                            'kpsq_uid': props.yh_id,
                                            'kpsq_uname': props.yh_name,
                                            'qy_id': props.qy_id,
                                            'qy_name': props.qy_name,
                                            'kpsq_name': info.kpsq_name,
                                            'kpsq_date': info.kpsq_date,
                                            'kpsq_kh_id': info.kpsq_kh_id,
                                            'kpsq_kh_name': info.kpsq_kh_name,
                                            'kpsq_sp_kpsq_amount': info.kpsq_amount,
                                            'kpsq_sp_dsbzd_id': info.kpsq_bzd_id,
                                            'kpsq_sp_dsbzd_name': info.kpsq_bzd_name,
                                            'kpsq_bm_id': info.kpsq_bm_id,
                                            'kpsq_bm_name': info.kpsq_bm_name,
                                            'kpsq_khfpxx_id': info.kpsq_khfpxx_id,
                                            'kpsq_khfpxx_name': info.kpsq_khfpxx_name,
                                            'kpsq_image_name': info.kpsq_image_name?info.kpsq_image_name:'',
                                            'kpsq_image_file': info.kpsq_image_file?info.kpsq_image_file:'',
                                            'kpsq_sp_kpsq_content': info.kpsq_content,
                                            'kpsq_spjd_bm_id': info.kpsq_bm_id,
                                            'kpsq_spjd_zflx': info.kpsq_zflx,
                                            'kpsq_spjd_amount': info.kpsq_amount,
                                            'kpsq_spjd_user_id': props.yh_id,
                                        }).then(res => {
                                            if(res.data.Status === 'success') {
                                                message.success('开票申请提交成功！')
                                            } else {
                                                message.error('开票申请提交失败！'+res.data.Message)
                                            }
                                        })
                                        .catch((err) => {
                                            message.error('开票申请提交失败！'+(err.response?.data?.Message||''))
                                        })
                                        .finally(() => {
                                            setIsSubmitting(false);
                                        })
                                    }} 
                                    disabled={isSubmitting}
                                    style={isSubmitting ? { opacity: 0.5, cursor: 'not-allowed' } : {}}
                                />  
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Modal>

        </>
    )
}

export default InvoiceEditReportEdit